import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { bodyPartsData } from "./bodymap.config.js";
import BodyMapRecordsTable from "./BodyMapTable";

// Example saved records
const savedRecords = [
  { id: 1, location: "Head", issue: "Bruise", type: "Minor", side: "front" },
  { id: 2, location: "Upper Back", issue: "Sprain", type: "Moderate", side: "back" },
  { id: 3, location: "Left Arm", issue: "Cut", type: "Minor", side: "front" },
];

const BodyMap = () => {
  const [selectedPart, setSelectedPart] = useState("");

  const handlePartSelect = (partName) => {
    setSelectedPart(partName);
  };

  return (
    <Box sx={{ textAlign: "center", p: 2 }}>
      {/* <Typography variant="h6" gutterBottom>
        Select Affected Body Part
      </Typography> */}

      {/* Body Images */}
      {/* <Box sx={{ display: "flex", justifyContent: "center", gap: 4, flexWrap: "wrap", userSelect: "none" }}>
        <Box sx={{ position: "relative", width: 350 }}>
          <Box component="img" src="/images/body-frontal.jpg" alt="Front" sx={{ width: "100%", borderRadius: 2 }} />
          {bodyPartsData.frontParts.map((part) => {
            const hasRecord = savedRecords.some((r) => r.location === part.name && r.side === "front");
            return (
              <Box
                key={part.id}
                onClick={() => handlePartSelect(part.name)}
                sx={{
                  position: "absolute",
                  left: part.x,
                  top: part.y,
                  width: part.width,
                  height: part.height,
                  backgroundColor: selectedPart === part.name
                    ? "rgba(25,118,210,0.3)"
                    : hasRecord
                    ? "rgba(255,165,0,0.3)" // highlight parts with records
                    : "transparent",
                  border: selectedPart === part.name ? "2px solid #1976d2" : "none",
                  borderRadius: 4,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "rgba(25,118,210,0.2)" },
                }}
                title={part.name}
              />
            );
          })}
        </Box>

        <Box sx={{ position: "relative", width: 350 }}>
          <Box component="img" src="/images/body-back.jpg" alt="Back" sx={{ width: "100%", borderRadius: 2 }} />
          {bodyPartsData.backParts.map((part) => {
            const hasRecord = savedRecords.some((r) => r.location === part.name && r.side === "back");
            return (
              <Box
                key={part.id}
                onClick={() => handlePartSelect(part.name)}
                sx={{
                  position: "absolute",
                  left: part.x,
                  top: part.y,
                  width: part.width,
                  height: part.height,
                  backgroundColor: selectedPart === part.name
                    ? "rgba(25,118,210,0.3)"
                    : hasRecord
                    ? "rgba(255,165,0,0.3)"
                    : "transparent",
                  border: selectedPart === part.name ? "2px solid #1976d2" : "none",
                  borderRadius: 4,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "rgba(25,118,210,0.2)" },
                }}
                title={part.name}
              />
            );
          })}
        </Box>
      </Box> */}

      {selectedPart && (
        <Typography variant="body1" sx={{ mt: 2, color: "primary.main", fontWeight: 600 }}>
          Selected: {selectedPart}
        </Typography>
      )}

      {/* Body Map Records Table */}
      <BodyMapRecordsTable />
    </Box>
  );
};

export default BodyMap;